import { Item as _Item } from '@studio/design-system/dropdown-menu';
import { Ellipses } from '@studio/design-system/label';
import { isElement } from 'react-is';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
// import { ConnectionStatus } from '#~/common/connection-status/connection-status.js'; TODO: add when we have the architecture in place
import { Badge } from '../../badge.jsx';
import type { ItemProps } from '../../types.js';

/** Iris vendor menu `<Item>` component with badges, status, and Ellipses. */
export const ItemIris = ({
  badges,
  className,
  children,
  icon,
  label,
  status,
  ...props
}: ItemProps): ReactElement => (
  <_Item
    className={twMerge(
      'h-34 border-b-0 text-md [&>div]:!w-full [&>div]:!items-center [&>div]:!justify-between',
      className
    )}
    icon={icon}
    label={
      !!label && isElement(label) ? (
        label
      ) : (
        <Ellipses className='max-w-[270px]' title={label}>
          {label}
        </Ellipses>
      )
    }
    {...props}
  >
    <div className='ml-auto flex flex-shrink-0 items-center gap-4'>
      {children}
      {badges && badges.length > 0 && (
        <>
          {badges.map((badge) => (
            <Badge key={badge.id} {...badge} />
          ))}
        </>
      )}
    </div>
  </_Item>
);
